import * as React from 'react';
import * as styles from './styles.css';
import { Tag } from '../../internal/components/Tag';
export var Tags = function Tags(props) {
  var _onClose = props.onClose,
    options = props.options,
    size = props.size;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['tags']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['tags_wrapper']
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement("div", {
      key: option.value,
      className: styles['tags_item']
    }, /*#__PURE__*/React.createElement(Tag, {
      onClose: function onClose() {
        return _onClose(option);
      },
      size: size
    }, option.label));
  })));
};
Tags.displayName = 'Tags';